

import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID, importProvidersFrom, Injectable } from '@angular/core';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';

import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';

import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation
} from '@azure/msal-browser';
import {
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalInterceptor,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration
} from '@azure/msal-angular';
import { environment } from 'src/environments/environment';



export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      authority: environment.authority,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: '/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    }
  });
}

/**
 * Configuração do Interceptor (Injeção automática de tokens)
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  // Mapeia sua API do CMS para exigir token
  protectedResourceMap.set(`${window.location.origin}${environment.apiCmsUrl}/*`, environment.consentScopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

/**
 * Configuração do Guard (Proteção de rotas)
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read', 'openid', 'profile', 'email']
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: IntlService, useClass: CldrIntlService },

    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(
      routes, 
      withEnabledBlockingInitialNavigation(),
      
      withInMemoryScrolling({ 
        anchorScrolling: 'enabled', 
        scrollPositionRestoration: 'enabled'
      })
    ),

    provideAnimationsAsync(),

    // CONFIGURAÇÃO OBRIGATÓRIA PARA MSAL v5: 
    // provideHttpClient deve obrigatoriamente usar withInterceptorsFromDi
    provideHttpClient(withInterceptorsFromDi()),

    // Registro do Interceptor no pipeline de requisições
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },

    // Provedores MSAL (v5)
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },

    // Serviços globais
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ]
};